import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import { ContentContainer, PageContainer } from '../components/ContentContainer';
import EditableTable from '../components/EditableTable';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const RetailerPage = () => {
  const navigate = useNavigate();
  const { retailer } = useParams();
  const [data, setData] = useState([]);
  const [stats, setStats] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`${config.serverUrl}/retailer/${retailer}`);
      setData(result.data);
    };
    fetchData();
  }, [retailer]);

  useEffect(() => {
    const fetchStats = async () => {
      const result = await axios.get(`${config.serverUrl}/retailers_stat/${retailer}`);
      setStats(result.data);
    };
    fetchStats();
  }, [retailer]);

  const handleSave = async (updatedItem) => {
    try {
      const retailerName = retailer;
      const row = updatedItem;

      await axios.post(`${config.serverUrl}/retailer/csv/row`, {
        retailer: retailerName,
        row: row
      });

      console.log("Row updated successfully");
    } catch (error) {
      console.error("Error updating row:", error);
    }
  };

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await axios.get(`${config.serverUrl}/cards_csv/${retailer}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'cards_data.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      const result = await axios.post(`${config.serverUrl}/retailer/update/${retailer}`);
      setData(result.data);
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  const generatePieChartData = (stats) => {
    return {
      labels: Object.keys(stats),
      datasets: [
        {
          label: 'Retailer Stats',
          data: Object.values(stats),
          backgroundColor: [
            '#75F94D', // Done
            '#A1FB8E', // Moderation
            '#8CFBCC', // Rendering
            '#8CE6FB', // Sizes configuration
            '#3282F6', // Evaluation
            '#EA3FF7', // In progress
            '#F08784', // Ready for work
            '#FFFE91', // On Hold
            '#F08650', // Backlog
            '#C72B1E', // Bad product
            '#C0C0C0'  // Not processed
          ],
          hoverBackgroundColor: [
            '#75F94D', // Done
            '#A1FB8E', // Moderation
            '#8CFBCC', // Rendering
            '#8CE6FB', // Sizes configuration
            '#3282F6', // Evaluation
            '#EA3FF7', // In progress
            '#F08784', // Ready for work
            '#FFFE91', // On Hold
            '#F08650', // Backlog
            '#C72B1E', // Bad product
            '#C0C0C0'  // Not processed
          ],
        },
      ],
    };
  };

  return (
    <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        <div className="App">
          <h1>Onboarding {retailer}</h1>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownload}
            disabled={isDownloading}
          >
            {isDownloading ? 'Preparing...' : 'Prepare cards csv'}
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            disabled={isUpdating}
          >
            {isUpdating ? 'Updating...' : 'Update'}
          </Button>

          <EditableTable data={data} onSave={handleSave} />
          <Box
            sx={{
              width: 800, // Adjust the width as needed
              height: 800, // Adjust the height as needed
              margin: '0 auto', // Center the chart horizontally
            }}
          >
            <Pie data={generatePieChartData(stats)} />
          </Box>
        </div>
      </ContentContainer>
    </PageContainer>
  );
};

export default RetailerPage;
